<template lang="html">
    <footer class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 py-20 max-w-[1200px] 
                   mx-auto gap-10 border-t px-5" >
        <div class="flex flex-col gap-4 md:col-span-3">
            <router-link to="/about">
                <h4 class="text-3x1 font-bold text-gray-700"> Contact </h4>
            </router-link>
             <div class="flex flex-col gap-3">
                 <a class="text-gray-500 font-semibold  hover:text-blue-700 transition duration-300 ease-in-out"> contact.pytheasdb@gmail.com  </a>
             </div>
        </div>
        <div class="flex flex-col gap-4 md:col-span-5">
           <h4 class="text-3x1 font-bold text-gray-700"> Please cite </h4>
            <div class="flex flex-col gap-3">
                <a href="https://doi.org/10.5582/irdr.2024.01043" class="text-gray-500 font-semibold  hover:text-blue-700 transition duration-300 ease-in-out"> Percheron <span class="italic"> et al. </span>  Intractable Rare Dis Res  (2024) </a>
            </div> 
        </div>
        <div class="flex flex-col gap-4 md:col-span-4 justify-start">
            <h4 class="text-3x1 font-bold text-gray-700">
                Sponsors
            </h4>
            <div class="flex flex-row gap-8 items-center flex-wrap relative -top-3">
                <a href="https://mirumpharma.com/" target="_blank" rel="noopener noreferrer">
                    <img class="h-12 w-auto object-contain" src="https://companieslogo.com/img/orig/MIRM_BIG-64e8aaee.png?t=1644879644" alt="Mirum Pharma">
                </a>
                <a href="https://www.ipsen.com/" target="_blank" rel="noopener noreferrer">
                    <img class="h-20 w-auto object-contain" src="https://www.ipsen.com/wp-content/uploads/2023/05/Ipsen-master-logo_RGB_350x260pix.png" alt="Ipsen">
                </a>
            </div>
        </div>
    </footer>
    <div class="bg-blue-600 text-white text-center py-3 px-5">
        <p style="display:inline-block;"> &copy; PytheasDB by GGS 2026. Supported by Mirum and Ipsen. </p>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="">
    
</style>
